import api from "@/lib/axios";

export const userService = {
  async getAllUsers(page = 1, searchParams = {}) {
    // Build query parameters
    const queryParams = new URLSearchParams();
    
    // Always add page parameter
    queryParams.append('page', page);
    
    // Add any additional search parameters
    Object.entries(searchParams).forEach(([key, value]) => {
      if (value) {
        queryParams.append(key, value);
      }
    });
    
    const response = await api.get(`/v1/users?${queryParams.toString()}`);
    return response.data;
  },

  async getUser(id) {
    const response = await api.get(`/v1/users/${id}`);
    return response.data;
  },

  async editUser(id) {
    const response = await api.get(`/v1/users/${id}/edit`);
    return response.data;
  },

  async updateUser(id, data) {
    const response = await api.put(`/v1/users/${id}`, data);
    return response.data;
  },

  async createUser(data) {
    const response = await api.post('/v1/users', data);
    return response.data;
  },

  async deleteUser(id) {
    const response = await api.delete(`/v1/users/${id}`);
    return response.data;
  },

  async massDelete(ids) {
    const response = await api.delete('/v1/users', { data: { ids } });
    return response.data;
  },

  async forceDelete(id) {
    const response = await api.delete(`/v1/users/forceDelete/${id}`);
    return response.data;
  },

  async getlegalAdvisors(page = 1, searchParams = {}) {
    // Build query parameters
    const queryParams = new URLSearchParams();
    
    // Always add page parameter
    queryParams.append('page', page);
    
    // Add any additional search parameters
    Object.entries(searchParams).forEach(([key, value]) => {
      if (value) {
        queryParams.append(key, value);
      }
    });
    
    const response = await api.get(`/v1/legal-advisors?${queryParams.toString()}`);
    return response.data;
  },
  async getlegalAdvisorsUnassigned() {
    const response = await api.get(`/v1/legal-advisors-unassigned`);
    return response.data;
  },
  async getheadOfDepartment(page = 1, searchParams = {}) {
    try {
      // Build query parameters
      const queryParams = new URLSearchParams();
      
      // Always add page parameter
      queryParams.append('page', page);
      
      // Add any additional search parameters
      Object.entries(searchParams).forEach(([key, value]) => {
        if (value) {
          queryParams.append(key, value);
        }
      });
      
      const response = await api.get(`/v1/head-of-departments?${queryParams.toString()}`);
      console.log('HOD API Response:', response);
      return response.data;
    } catch (error) {
      console.error('Error in getheadOfDepartment:', error);
      throw error;
    }
  },

  async getUserData(userId) {
    const response = await api.get(`/v1/get-user-data?user_id=${userId}`);
    return response.data;
  },
   // async getUserData(userId) {
  //   const response = await api.get(`/api/v1/get-user-data?user_id=${userId}`);
  //   return response.data;
  // },
  async updateUserData(userId, data) {
    const response = await api.put(`/api/v1/users/${userId}`, data);
    return response.data;
  },

  async deleteUserData(userId) {
    const response = await api.delete(`/api/v1/users/${userId}`);
    return response.data;
  },
  
  // Add executor to user
  async addExecutor(data) {
    const response = await api.post('/v1/store/user/executor', data);
    return response.data;
  },
  
  // Get user's executors
  async getMyExecutors() {
    const response = await api.get('/v1/executors/my');
    return response.data;
  },

  // Add this method to fetch user progress
  getUserProgress: async (userId) => {
    try {
      if (!userId) {
        throw new Error('No user ID provided');
      }
      
      const response = await api.get(`/v1/get-user-data`, {
        params: { user_id: userId }
      });
      
      return response.data;
    } catch (error) {
      console.error('Error fetching user progress:', error);
      throw error;
    }
  },

  // Mark user as deceased
  markUserAsDeceased: async (userId) => {
    try {
      const response = await api.post('/v1/deceased-user', { user_id: userId });
      return response.data;
    } catch (error) {
      console.error('Error marking user as deceased:', error);
      throw error;
    }
  },

  // Add new user API call
  handleNewUser: async () => {
    try {
      const response = await api.get('/v1/new_user');
      console.log('New User API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in handleNewUser:', error);
      throw error;
    }
  }
};
